import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ABMRolesService } from '@services/abm-roles-service';

@Component({
  selector: 'app-edit-acopio-dialog',
  templateUrl: './edit-acopio-dialog.component.html',
  styleUrls: ['./edit-acopio-dialog.component.scss']
})
export class EditAcopioDialogComponent implements OnInit {

  public acopio: any;
  public formNewAcopio = this.formBuilder.group({
    'acopio': new FormControl(),
  })
  constructor(private dialogRef: MdDialogRef<EditAcopioDialogComponent>,
              public formBuilder: FormBuilder,
              private abmService: ABMRolesService) { }

  ngOnInit() {
    if(this.acopio.ParentId){
      this.abmService.getAcopioById(this.acopio.ParentId).subscribe(data => {
        let autoCompleteValue = [data]
        this.formNewAcopio.get('acopio').setValue(autoCompleteValue)
      })
    }
  }

  onSubmit(){
    let central = {
      idCentral: null
    };

    let value = this.formNewAcopio.get('acopio').value;
    if(value !== null && value.length > 0){
      central.idCentral = this.formNewAcopio.get('acopio').value[0].Id
    }
    this.abmService.setAcopioCentral(this.acopio.Id, central).subscribe({
      next:data => {
        if(data === true){
          this.dialogRef.close(true);
        }else{
          this.dialogRef.close(false);
        }
      },
      error:error =>{
        this.dialogRef.close(false);
      }
    })
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/edit-acopio-dialog/edit-acopio-dialog.component.ts